/* eslint-disable array-callback-return */
import { useState, useEffect } from "react"
import StadeoNavbar from "../../components/StadeoNavbar"
import TicketCard from "../../components/TicketCard"
import bgicon from "../../assets/svg/bgicon.svg"
import accountImage from "../../assets/png/account.png"
import LoginModal from "../../components/LoginModal"
import LogoutModal from "../../components/LogoutModal"
import PurchasedModal from "../../components/PurchasedModal"
import { ReactSVG } from "react-svg";
import ticketSingle from "../../assets/svg/ticket_single.svg";
import arrowSVG from "../../assets/svg/arrow.svg"
import { createCheckout, createinvoice, productlist } from "../../fetch/api/ticketCard";
import { message as AndMessage, Spin } from "antd";
import LoadingModal from "../../components/LoadingModal/index";

function Checkout() {
  const [currencyDropdown, setCurrencyDropdown] = useState(false);
  const [pickedCurrency, setPickedCurrency] = useState('EUR');
  const [showLoginModal, setShowLoginModal] = useState('');
  const [accountImages, setAccountImage] = useState(localStorage.getItem('login') ? JSON.parse(localStorage.getItem('login')).avatar_small : accountImage);
  const [showPurchasedModal, setShowPurchasedModal] = useState(false)
  const [ticketlist, setTicketlist] = useState([])
  const obtainUrl = () => {
    let urlArr;
    let urlData = decodeURIComponent(window.location.search);
    let temp = urlData.replace('?', '');
    urlArr = temp.split('&');
    let URLdata = {};
    let temp1 = [];
    for (let i = 0; i < urlArr.length; i++) {
      temp1 = urlArr[i].split('=');
      URLdata[temp1[0]] = temp1[1];
    }
    temp1 = [];
    return URLdata
  }
  const getproductlist = (pickedCurrencys) => {
    productlist({ currency: pickedCurrencys }).then(res => {
      setTicketlist(res.data)
    })
  }
  useEffect(() => {
    let ResultPayment = obtainUrl()
    if (ResultPayment.res == "success") {
      let login = JSON.parse(localStorage.getItem("login"));
      if (login) {
        setShowPurchasedModal(true)
      }

    } else {
      window.history.pushState('', '', window.location.origin);
    }
    getproductlist(pickedCurrency)
  }, [])
  const setAvatar = () => {
    localStorage.getItem('login') ? setAccountImage(JSON.parse(localStorage.getItem('login')).avatar_small) : setAccountImage(accountImage)
    setShowLoginModal('')
  }

  return (
    <div className="relative min-h-screen bg-stadeo-bg overflow-clip flex flex-col">

      <StadeoNavbar />
      {
        showLoginModal === 'login' ? (
          <LoginModal setAvatar={setAvatar} />
        ) : showLoginModal === 'logout' ? (
          <LogoutModal setAvatar={setAvatar} />
        ) : null
      }
      {
        showPurchasedModal ? <PurchasedModal toggleModal={() => {
          window.history.pushState('', '', window.location.origin);
          setShowPurchasedModal(false)
        }} /> : null
      }

      <div className="h-[40px] bg-stadeo-orange text-center">
        <p className="text-white text-[12px] md:text-[12px] font-bold font-worksans pt-[10px]">-10/15/20% DISCOUNT when YOU BUY ONLINE</p>
      </div>
      <div className="ml-[30px] md:ml-[40px] mt-[20px] w-[30px] md:w-[60px] cursor-pointer hover:ml-[30px]" onClick={() => { window.location.href = 'https://www.stadeo.com' }}>
        <ReactSVG className="ReactSVG" src={arrowSVG}/>
      </div>
      <div className="absolute right-[26px] md:right-[29px] top-[125px] md:top-[150px] flex items-center">
        {
          JSON.parse(localStorage.getItem('login')) ? <div className="  bg-white mr-[26px] h-[37px] pl-[36px] pr-[19px] flex items-center text-[18px] font-medium relative rounded-[75px] rounded-bl-[225px]">
            <div className=" absolute left-[-15px] w-[33px] h-[25px]">
              <ReactSVG className="ReactSVG " src={ticketSingle} />
            </div>
            <span className="z-[1] min-w-[56px] text-center">{JSON.parse(localStorage.getItem('login')).u_coin}</span>

          </div> : null
        }

        <div className=" w-[41px] h-[41px] bg-stadeo-black-gray  rounded-full border-2 cursor-pointer overflow-hidden"
          onClick={() => {
            if (localStorage.getItem('login')) {
              setShowLoginModal('logout')
            } else {
              setShowLoginModal('login')
            }
          }}>

          <img alt='account' src={accountImages} className="w-[100%] h-[100%] rounded-full" />
        </div>
      </div>


      <div className="ml-[23px] md:ml-[46px]">
        <div className="mt-[66px] md:mt-[50px] w-full">
          <p className="text-[60px] md:text-[80px] font-monumentextended font-bold text-white leading-[50px]">TOP UP <span className="text-[38px] md:text-[80px] block md:inline leading-[36px]">YOUR TICKETS</span></p>
        </div>

        <div className="mt-[20px] md:mt-[40px] w-full">
          <p className="text-[20px] md:text-[24px] font-worksans text-white leading-[24px] md:leading-[18px]">With tickets you can unlock premium experiences within Stadeo, like special reactions or exclusive rooms</p>
        </div>

        <div className="mt-[20px] md:static md:mt-[35px]">
          <p className="text-[12px] font-worksans font-semibold text-white">Currency:</p>
          <div className="relative inline-block text-left mt-[12px]">
            <div>
              <button type="button" className="inline-flex w-[90px] h-[34px] rounded-[154px] bg-white pl-[22px] py-[6px] text-[14px] text-stadeo-blue hover:bg-gray-50" aria-expanded="true" aria-haspopup="true"
                onClick={() => {
                  setCurrencyDropdown(!currencyDropdown)
                }}>
                {pickedCurrency}
                <svg
                  className="absolute left-[61px] top-[13px] cursor-pointer"
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.412063 0.740937C0.136083 1.00635 0.136083 1.43427 0.412063 1.69969L5.09247 6.20094C5.31213 6.41219 5.66696 6.41219 5.88662 6.20094L10.567 1.69969C10.843 1.43427 10.843 1.00635 10.567 0.740936C10.291 0.47552 9.84609 0.47552 9.57011 0.740936L5.48672 4.6626L1.40334 0.735521C1.13299 0.475521 0.682412 0.475521 0.412063 0.740937Z"
                    fill="#283AC6"
                  />
                </svg>
              </button>
            </div>

            {
              currencyDropdown ? (
                <div className="absolute left-[95px] bottom-[0px] z-[99] mt-2 w-[75px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                  <div className="py-1" role="none">
                    <p onClick={() => {
                      setPickedCurrency('EUR');
                      setCurrencyDropdown(!currencyDropdown);
                      getproductlist('EUR')
                    }} className="text-gray-700 block px-4 py-2 text-sm cursor-pointer" role="menuitem" tabIndex="1" id="menu-item-0">EUR</p>
                    <p onClick={() => {
                      setPickedCurrency('IDR');
                      setCurrencyDropdown(!currencyDropdown);
                      getproductlist('IDR')
                    }} className="text-gray-700 block px-4 py-2 text-sm cursor-pointer" role="menuitem" tabIndex="2" id="menu-item-1">IDR</p>
                    <p onClick={() => {
                      setPickedCurrency('USD');
                      setCurrencyDropdown(!currencyDropdown);
                      getproductlist('USD')
                    }} className="text-gray-700 block px-4 py-2 text-sm cursor-pointer" role="menuitem" tabIndex="3" id="menu-item-2">USD</p>
                  </div>
                </div>
              ) : null
            }

          </div>
        </div>

        <div className="s390:ml-[6px] s414:ml-[16px] md:ml-0 relative z-20">
          <div className="flex flex-wrap md:overflow-x-auto pr-2">
            {ticketlist.map((item, index) => <div className="mr-[17px] s390:mr-[20px] s414:mr-[26px] md:mr-[22px]" key={item.product_name}>
              <TicketCard
                discountPercentage={item.bonus}
                ticketAmount={item.coin}
                price={item.price}
                p_labnel={item.p_labnel}
                bonusPercentage={item.bonus}
                icon={item.image}
                price_text={item.price_text}
                productClicked={() => {
                  if (localStorage.getItem('login')) {
                    LoadingModal.open()
                    if (pickedCurrency == 'IDR') {
                      createinvoice({
                        product_name: item.product_name,
                        currency: pickedCurrency
                      }).then(res => {
                        if (res) {
                          const { code, data, message } = res
                          if (code == 200) {
                            window.location.href = data.url
                          } else {
                            AndMessage.error({
                              content: message,
                              maxCount: 1,
                            });
                          }
                        }
                      })
                    } else {
                      createCheckout({
                        product_name: item.product_name,
                        currency: pickedCurrency
                      }).then(res => {
                        if (res) {
                          const { code, data, message } = res
                          if (code == 200) {
                            window.location.href = data.url
                          } else {
                            AndMessage.error({
                              content: message,
                              maxCount: 1,
                            });
                          }
                        }
                      })
                    }
                  } else {
                    setShowLoginModal('login')
                  }
                }}
              />
            </div>)}
          </div>
        </div>
      </div>
      <div className="w-full h-[216px] md:h-auto relative md:flex-1 pointer-events-none">
        <div id="prx" className="absolute right-[0px] bottom-0 w-[187px] md:w-[240px]">
          <ReactSVG className="ReactSVG" src={bgicon} />
        </div>
      </div>



    </div>
  )
}

export default Checkout